import { createAction, props } from '@ngrx/store';
import { ContactUpdateError } from '../../interfaces';

export const InitiateMobilePhoneUpdateAction = createAction(
    '[Contact Update] Initiate Mobile Phone Update',
    props<{ newPhone: string; expectedLastModifiedDate: string }>()
);

export const InitiateMobilePhoneUpdateSuccessAction = createAction(
    '[Contact Update] Initiate Mobile Phone Update Success',
    props<{ verificationId: string; destinationMasked: string }>()
);

export const InitiateMobilePhoneUpdateFailureAction = createAction(
    '[Contact Update] Initiate Mobile Phone Update Failure',
    props<{ error: ContactUpdateError }>()
);

export const VerifyMobilePhoneAction = createAction(
    '[Contact Update] Verify Mobile Phone',
    props<{ verificationId: string; otpCode: string }>()
);

export const VerifyMobilePhoneSuccessAction = createAction(
    '[Contact Update] Verify Mobile Phone Success',
    props<{ newPhone: string }>()
);

export const VerifyMobilePhoneFailureAction = createAction(
    '[Contact Update] Verify Mobile Phone Failure',
    props<{ error: ContactUpdateError }>()
);

export const ResetContactUpdateAction = createAction(
    '[Contact Update] Reset'
);
